import BaseService from "./BaseService";
import {
  CashflowMonthlyResponse,
  SuppliersResponse,
  Supplier,
} from "models/CashflowModel";

class CashflowService extends BaseService {
  async getMonthlyBreakdown(params: {
    startMonth: string;
    endMonth: string;
    status?: string;
    brand?: string;
  }): Promise<CashflowMonthlyResponse | null> {
    await this._getAccessToken();

    return this.handleHttpRequest<CashflowMonthlyResponse>(
      () => this.http.get("cashflow/monthly", { params }),
      "Failed to fetch /cashflow/monthly",
    );
  }

  async getSuppliers(): Promise<SuppliersResponse | null> {
    await this._getAccessToken();

    return this.handleHttpRequest<SuppliersResponse>(
      () => this.http.get("suppliers"),
      "Failed to fetch /suppliers",
    );
  }

  async createSupplier(supplier: {
    name: string;
    maxOrderAmount?: number | null;
    tariffRate?: number | null;
    paymentTerms: Supplier["paymentTerms"];
  }): Promise<SuppliersResponse | null> {
    await this._getAccessToken();

    return this.handleHttpRequest<SuppliersResponse>(
      () => this.http.post("suppliers", supplier),
      "Failed to create supplier",
    );
  }

  async updateSupplier(
    id: number,
    supplier: {
      name: string;
      maxOrderAmount?: number | null;
      paymentTerms: Supplier["paymentTerms"];
    },
  ): Promise<SuppliersResponse | null> {
    await this._getAccessToken();

    return this.handleHttpRequest<SuppliersResponse>(
      () => this.http.put(`suppliers/${id}`, supplier),
      "Failed to update supplier",
    );
  }

  async deleteSupplier(id: number): Promise<{ deleted: number } | null> {
    await this._getAccessToken();

    return this.handleHttpRequest<{ deleted: number }>(
      () => this.http.delete(`suppliers/${id}`),
      "Failed to delete supplier",
    );
  }
}

export default CashflowService;
